const locales = {
  production: ['en', 'sv', 'da', 'fi', 'nb', 'de' /* , nl */],
  development: ['en', 'sv', 'da', 'fi', 'nb', 'de' /* , nl */],
  test: ['en', 'sv', 'da', 'fi', 'nb', 'de' /* , nl */],
};
module.exports = locales[process.env.NODE_ENV];
